import React from "react";
import { Button } from '../ui/components';
import { command$ } from '../observables/command';
import { CommandID } from '../commands';
export default function NoConnections() {
    return React.createElement("div", { className: "fill-center" },
        React.createElement("div", { className: "center" },
            React.createElement("div", { className: 'icon' }, "cloud_upload"),
            React.createElement("p", null, "No site connections found."),
            React.createElement("p", null,
                React.createElement(Button, { onClick: () => command$.next({ id: CommandID.NewFile }), primary: true }, "Create New Connection..."))));
}
